module.exports = __webpack_public_path__ + "img/vestuario copy.b63ae56a.svg";